/**
* @name APP parvulo
* @description
* # name controller --> learningObjetivesCreateController
* # As Controller --> learningObjetivesCreate
* brief comment controller creation levels users
*/

export default class learningObjetivesCreateController {
  	constructor($scope,levelsServices,coresServices,learningObjetivesServices,ngNotify,UserInfoConstant,$state,$filter) {
		this.$scope = $scope
		this.ngNotify = ngNotify
		this.$state = $state
		this.levelsServices = levelsServices.services
		this.coresServices = coresServices.services
		this.services = learningObjetivesServices.services
		this.$scope.grid = false
		this.$translate = $filter('translate');
        this.conceptId = 0
		this.$scope.levelSelect = null
		this.$scope.coreSelect = null
		this.$scope.name = null
		this.learningObjetiveId = null
		this.$scope.code = null
		
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});
   	}

	init(){
		const params = {
			concept_id: this.conceptId
		}

		this.getLevels(params)
		this.getCores(params)
	}

	getLevels(params){
		this.levelsServices.getLevels(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.levelsList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getCores(params){
		this.coresServices.getCores(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.coresList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	beforeSave(){
		if(this.$scope.name === null) {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.$scope.code === null) {
			this.ngNotify.set('Indique código','warn')
			return
		}

		if(this.$scope.levelSelect === null) {
			this.ngNotify.set('Seleccione un Nivel','warn')
			return
		}

		if(this.$scope.coreSelect === null) {
			this.ngNotify.set('Seleccione un Núcleo','warn')
			return
		}

		this.$scope.isDisabled = true;
		let params  = { 
			name   : this.$scope.name,
			code   : this.$scope.code,
			user_id : this.user_id,
			concept_id: this.conceptId,
			level_id: this.$scope.levelSelect,
			core_id: this.$scope.coreSelect
		}

		this.save(params)
	}

	save(params){
		this.services.saveLearningObjetives(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado el Objetivo de Aprendizaje correctamente','success');
				this.$state.go("app.learningObjetives");
			}else{
				this.ngNotify.set('Error con servicio check request','error');
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de Objetivo de Aprendizaje ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})
	}
}
learningObjetivesCreateController.$inject=['$scope', 'levelsServices', 'coresServices', 'learningObjetivesServices', 'ngNotify','UserInfoConstant','$state','$filter']








// WEBPACK FOOTER //
// ./src/app/admin-panel/learningObjetives/create/learningObjetivesCreateController.js